import { DataForColumn } from '../../../types'
import _ from 'lodash'

export const getColumnOverrides = (
	compId: string,
	dataForColumn: Partial<DataForColumn> = {},
	compAlignment: number,
	siteWidth: number,
	isMobileView: boolean = false
) => {
	const columnOverrides = {
		width: '100%',
		contentArea: {
			alignment: compAlignment / 100,
			width: siteWidth,
		},
	}

	if (isMobileView) {
		return columnOverrides
	}

	// calculate contentArea.width
	const { parentCompProps = {}, siblings = [] } = dataForColumn
	const structureWidths = siblings.map((sibling) => _.get(sibling, 'layout.width') as number)
	const columnCount = structureWidths.length
	const minContentWidth = siteWidth - parentCompProps.frameMargin * 2
	const totalContentWidth = minContentWidth - parentCompProps.columnsMargin * (columnCount - 1)
	const columnsTotalStructureWidth = structureWidths.reduce((a, b) => a + b, 0)
	const contentWidths = structureWidths.map((structureWidth) =>
		Math.round((structureWidth * totalContentWidth) / columnsTotalStructureWidth)
	)
	const normalizedContentWidths = contentWidths.map(
		(structureWidth, index) =>
			structureWidth + (index === 0 ? totalContentWidth - contentWidths.reduce((a, b) => a + b, 0) : 0)
	)
	const childIndex = siblings.findIndex((comp) => comp.id === compId)

	columnOverrides.contentArea.width = normalizedContentWidths[childIndex]

	return columnOverrides
}
